<template>
  <div class="Box">
    <el-card class="box-card">
      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="35">
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="ID">
              <el-input v-model="queryParams.id" @change="search" @clear="search" placeholder="请输入渠道号ID" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="渠道号">
              <el-input v-model="queryParams.channel_code" @change="search" @clear="search" placeholder="请输入渠道号" clearable></el-input>
<!--              <SelectChecked :options="referralOptions" :isRemoveAllTag="isRemoveAllTag" placeholder="请选择渠道号" @selectedVal="selectedReferral"/>-->
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="推广链接名称">
              <el-input v-model="queryParams.channel_name" @change="search" @clear="search" placeholder="请输入推广链接名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="负责人">
              <el-input v-model="queryParams.owner" @change="search" @clear="search" placeholder="请输入负责人" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="投放类型">
              <el-select v-model="queryParams.status" @change="search" @clear="search" placeholder="请选择投放类型" clearable class="w100">
                <el-option label="有效" value="1"></el-option>
                <el-option label="停投" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="平台类型">
              <el-select v-model="queryParams.platform_type" @change="search" @clear="search" placeholder="请选择平台类型" clearable class="w100">
                <el-option label="抖音" value="1"></el-option>
                <el-option label="微信" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="媒体">
              <el-input v-model="queryParams.media" @change="search" @clear="search" placeholder="请输入媒体" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="时间段">
              <el-date-picker style="width: 100%" v-model="queryParams.user_createtime" type="daterange" align="right"
                unlink-panels start-placeholder="开始时间" end-placeholder="结束时间" :picker-options="pickerOptions"
                @change="handTime">
              </el-date-picker>
            </el-form-item>
          </el-col> -->
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button type="primary" size="medium" @click="search">查询</el-button>
              <el-button size="medium" @click="addNoNe">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="div_buttom">
        <el-button size="medium" @click="addNoNe">刷新列表</el-button>
        <!-- <el-button size="medium" type="primary" icon="el-icon-plus" @click="addList">导出</el-button> -->
        <!--				<el-button size="medium" type="primary" icon="el-icon-search" @click="addSearch">打开搜索</el-button>-->
      </div>

      <el-table
          ref="multipleTable"
          :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          border
          v-loading="loading"
          size="medium"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="ID" width="80">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>
        <el-table-column prop="name" label="渠道号" width="300">
          <template slot-scope="scope">{{ scope.row.channel_code }}</template>
        </el-table-column>
        <el-table-column prop="name" label="推广链接名称" width="180">
          <template slot-scope="scope">{{ scope.row.channel_name }}</template>
        </el-table-column>
        <el-table-column prop="name" label="小说信息" width="180">
          <template slot-scope="scope">{{ scope.row.book_id }}-{{ scope.row.book_name }}</template>
        </el-table-column>
        <el-table-column prop="name" label="新用户客单价" width="180">
          <template slot-scope="scope">{{ scope.row.new_aov }}</template>
        </el-table-column>
         <el-table-column prop="name" label="新用户充值人数" width="180">
          <template slot-scope="scope">{{ scope.row.new_recharge_user }}</template>
        </el-table-column>
         <el-table-column prop="name" label="新用户充值金额" width="180">
          <template slot-scope="scope">{{ scope.row.new_recharge_money }}</template>
        </el-table-column>
        <el-table-column prop="name" label="付费笔数" width="120">
          <template slot-scope="scope">{{ scope.row.recharge_num }}</template>
        </el-table-column>
        <el-table-column prop="name" label="付费金额" width="120">
          <template slot-scope="scope">{{ scope.row.recharge_money }}</template>
        </el-table-column>
        <el-table-column prop="name" label="付费率" width="120">
          <template slot-scope="scope">{{ scope.row.recharge_rate }}</template>
        </el-table-column>
        <el-table-column prop="name" label="负责人" width="120">
          <template slot-scope="scope">{{ scope.row.owner }}</template>
        </el-table-column>
        <el-table-column prop="name" label="媒体名称" width="120">
          <template slot-scope="scope">{{ scope.row.media }}</template>
        </el-table-column>
        <el-table-column prop="name" label="平台类型" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.platform_type == 1">抖音</span>
            <span v-if="scope.row.platform_type == 2">微信</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="投放类型" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">有效</span>
            <span v-if="scope.row.status == 3">停投</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="调起信息" width="120">
          <template slot-scope="scope">
            <el-link type="primary" @click="addSee(scope.row)">查看</el-link>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="name" label="二维码" width="120">
          <template slot-scope="scope">
            <el-popover
                placement="right"
                width="200"
                trigger="hover"
                @show="popoverShow(scope.row.image, scope.row.channel_code)"
            >
              <div class="demo-image__placeholder">
                <div class="block">
                  <el-image :src="qrCode" :preview-src-list="qrCodeList">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </div>
              </div>
              <el-link type="primary" slot="reference">预览</el-link>
            </el-popover>
          </template>
        </el-table-column> -->
        <el-table-column prop="name" label="创建时间" width="180">
          <template slot-scope="scope">{{ scope.row.created_at }}</template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <!-- <el-button type="text" size="medium" v-if="roleIds==4" @click="findLook(scope.row)">定价</el-button> -->
            <el-button type="text" size="medium" v-if="roleIds==4" @click="addEdit(scope.row)">编辑</el-button>
            <!-- <el-button type="text" size="medium" @click="addOpen(scope.row)">查看</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo" :limit.sync="queryParams.pageSize"
                  @pagination="getList"/>
      <AddChannel v-if="AddFlag" :AddFlag="AddFlag" @NoneChannel="NoneChannel" :tableObj="tableObj"
                  @AddOk="AddOk"></AddChannel>
      <TurnitupList
          v-if="dialogTableVisible"
          :channel_code="channel_code"
          :close-on-click-modal="false"
          :dialogTableVisible="dialogTableVisible"
          @NoneDlog="NoneDlog"
          :codeList="codeList"
          :seeid="seeid"
      ></TurnitupList>
      <tabDlg v-if="innerVisible" :innerVisible="innerVisible" :id="id" @noneDlg="noneDlg"></tabDlg>
      <!-- <LookMoney v-if="MoneyVisible" :MoneyVisible="MoneyVisible" @NoneMoney="NoneMoney" :MoneyObj="MoneyObj"></LookMoney> -->
      <div class="drawer-wrapper">
        <el-drawer :wrapperClosable="true" title="编辑章节" :visible.sync="MoneyVisible" size="50%" :before-close="handleCloseMoney">
          <div class="demo-drawer__content">
            <el-form :model="EditFrom" size="medium" label-width="80px" class="mt35" ref="ruleForm" :rules="rules">
              <el-row :gutter="35" class="center-content">
                <el-col :xs="24" :sm="12" :md="8" :lg="18" :xl="20" class="mb20">
                  <el-form-item label="单集价格" prop="o_episode_price">
                    <div class="input-with-pcenter">
                      <el-input v-model.number="EditFrom.o_episode_price" placeholder="请输入单集价格"
                                clearable style="width: 100%;"></el-input>
                      <p class="pcenter">单集价格范围{{ chapter.episode_priceone }}-{{ chapter.episode_pricetwo }}</p>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="18" :xl="20" class="mb20">
                  <el-form-item label="免费集数" prop="o_free_episode">
                    <div class="input-with-pcenter">
                      <el-input v-model.number="EditFrom.o_free_episode" placeholder="请输入免费集数"
                                clearable></el-input>
                      <p class="pcenter">免费集数范围{{ chapter.free_episodeoneone }}-{{ chapter.free_episodetwo }}</p>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>

          <div class="demo-drawer__footer">
            <el-button @click="MoneyVisible=false">取 消</el-button>
            <el-button type="primary" @click="submitMoney">确 定</el-button>
          </div>

        </el-drawer>
      </div>
    </el-card>
  </div>
</template>

<script>
import {channelNumberAPI} from '@/api/popularize/channelNumber';
import AddChannel from './component/AddChannel.vue';
import TurnitupList from './component/TurnitupList.vue';
import {Session} from '@/utils/storage';
import tabDlg from './component/tabDlg.vue';
import {playletAPI} from '@/api/popularize/playletList';
import {processErrors} from "@/utils/errorHandler";
import {useLoginApi} from "@/api/login";
import {GeneralCollectApi} from '@/api/statistics/comStatistics/index';
import SelectChecked from '@/components/Select/SelectChecked'

export default {
  components: {
    AddChannel,
    TurnitupList,
    tabDlg,
    SelectChecked
  },
  data() {
    return {
      roleIds: '',
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        id: '',
        channel_code: '',
        channel_name: '',
        owner: '',
        status: '',
        platform_type: '',
        media: '',
        start_date: '',
        end_date: '',
      },
      AddID: '',
      appidList: [],
      page: {
        pageNo: 1,
        pageSize: 999,
        type: '4',
      },
      tableData: [],
      multipleSelection: [],
      editID: '',
      // 总条数
      total: 0,
      SearchFlag: false,
      AddFlag: false,
      dialogTableVisible: false,
      // TurnitupObj: {},
      tableObj: {},
      channel_code: '',
      innerVisible: false,
      MoneyVisible: false,
      MoneyObj: {},
      id: '',
      codeList: [],
      seeid: "",
      EditFrom: {
        o_episode_price: '',
        o_free_episode: '',
        id: ""
      },
      PointObj: {},
      chapter: {
        episode_priceone: '',
        episode_pricetwo: '',
        free_episodeoneone: '',
        free_episodetwo: '',
      },
      rules: {
        o_episode_price: [
          {required: true, message: '请输入单集价格', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              if (value === null || value < this.chapter.episode_priceone || value > this.chapter.episode_pricetwo) {
                callback(new Error('单集价格必须在' + this.chapter.episode_priceone + '和' + this.chapter.episode_pricetwo + '之间'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
        o_free_episode: [
          {required: true, message: '免费集数范围', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              if (value === null || value < this.chapter.free_episodeoneone || value > this.chapter.free_episodetwo) {
                callback(new Error('免费集数必须在' + this.chapter.free_episodeoneone + '和' + this.chapter.free_episodetwo + '之间'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
      },
      loading: false,
      referralOptions: [],//选择渠道号列表
      isRemoveAllTag: 0,//下拉框是否清空
      qrCode:'../../../../assets/btn/zhantie.png',
      qrCodeList:[],
    };
  },
  created() {
    this.getUserinfo();
    this.getList();
    this.getSelectReferral();
  },
  methods: {

    popoverShow(image,channel_code){
      this.qrCode = '../../../../assets/btn/zhantie.png';
      if(image){
        this.qrCode = image;
      }else{
        const api = channelNumberAPI();
        let params = {
          channel_code: channel_code
        };
        api.getQrcode(params)
            .then((res) => {
              if (res.code == 0) {
                this.qrCode = res.data;
                this.qrCodeList = [res.data]
              } else {
                processErrors(res);
              }
            })
            .catch((error) => {
            });
      }
    },
    /**
     * 选择渠道号
     */
    selectedReferral(value) {
      this.queryParams.channel_code = value;
    },
    /**
     * 获取选择渠道号列表
     */
    getSelectReferral() {
      const api = GeneralCollectApi();
      api.getSelectReferral()
          .then((res) => {
            if (res.code == 0) {
              let data = res.data;
              this.referralOptions = data.map(item => ({
                value: item.channel_code,
                label: item.channel_code,
                label_en: item.movie_name + '-' + item.episodes_name + '-' + item.channel_name,
                check: false
              }));
            } else {
              processErrors(res);
            }
          })
          .catch((error) => {
          });
    },

    getUserinfo() {
      const api = useLoginApi();
      api.getUserinfo().then((res) => {
        this.roleIds = res.data.roleId
      })
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getList() {
      this.loading = true
      let api = channelNumberAPI();
      api.getchanneleList(this.queryParams).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.total = res.data.totalCount;
        } else {
          processErrors(res);
        }
        this.loading = false
      });
    },
    getclassifyList() {
      let api = playletAPI();
      api.classifyList(this.page).then((res) => {
        if (res.code == 0) {
          this.appidList = res.data;
        } else {
          processErrors(res);
        }
      });
    },
    // 打开搜索
    addSearch() {
      if (this.SearchFlag == false) {
        this.SearchFlag = true;
      } else {
        this.SearchFlag = false;
      }
    },

    // 搜索
    search() {
      this.getList();
    },
    // 重置列表
    addNoNe() {
      this.isRemoveAllTag += 1;
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
      };
      this.getList();
    },

    addSee(row) {
      this.dialogTableVisible = true;
      this.seeid = row.id
      let codesArray = row.channel_code.split(',');
      let codesObjects = codesArray.map((code) => {
        // let randomKey = generateRandomKey();
        return {code: code, id: row.id, rowid: Math.floor(Math.random() * 1000000)};
      });
      this.codeList = codesObjects
      // this.channel_code = row.channel_code_list;
      // let obj = {
      // 	id: row.id,
      // 	channel_code_list: row.channel_code_list,
      // };
      // let api = channelNumberAPI();
      // api.Turnitup(obj).then((res) => {
      // 	if (res.code == 0) {
      // 		this.TurnitupObj = res.data;
      //
      // 	}
      // });
    },
    addList() {
      if (this.multipleSelection.length <= 0) {
        this.$message.error('请最少选择1条');
      } else {
        const urlParams = new URLSearchParams();

        if (this.multipleSelection && Array.isArray(this.multipleSelection)) {
          this.multipleSelection.forEach((item) => {
            urlParams.append('channel_codes[]', item.channel_code);
          });
        }

        let url = new URL(window.location.href);
        let token = url.searchParams.get('token');
        if(token!==null){
          urlParams.append('token', token)
        } else if (Session.get('token')) {
          urlParams.append('token', Session.get('token'))
        }
        // 获取基础 URL
        const baseExportUrl = process.env.VUE_APP_BASE_API + '/admin/referral/export';
        // 拼接 URL 参数
        const fullExportUrl = baseExportUrl + '?' + urlParams.toString();
        window.location.href = fullExportUrl;
      }
    },
    // 关闭调起信息
    NoneDlog() {
      this.dialogTableVisible = false;
    },
    AddOk() {
      this.AddFlag = false;
      this.getList();
    },
    findLook(row) {
      this.EditFrom.id = row.id;
      this.EditFrom.o_episode_price = row.o_episode_price;
      this.EditFrom.o_free_episode = row.o_free_episode;
      // this.MoneyObj=row
      this.MoneyVisible = true
      let api = playletAPI();
      // api.freepoint(row.movie_id).then((res) => {
      //   if (res.code == 0) {
      //     this.FlagEdit = true;
      //     // this.EditFrom.id = row.id;
      //     // this.EditFrom.o_episode_price = res.data.o_episode_price;
      //     // this.EditFrom.o_free_episode = res.data.o_free_episode;
      //     this.chapter.episode_priceone = res.data.episode_price_range[0];
      //     this.chapter.episode_pricetwo = res.data.episode_price_range[1];
      //     this.chapter.free_episodeoneone = res.data.free_episode_range[0];
      //     this.chapter.free_episodetwo = res.data.free_episode_range[1];
      //   } else {
      //     processErrors(res);
      //   }
      // });
    },
    submitMoney() {
      let api = channelNumberAPI();
      api.opepisode(this.EditFrom).then((res) => {
        if (res.code == 0) {
          this.$message.success('修改成功')
          this.MoneyVisible = false
          this.getList();
        }
      })
    },
    handleCloseMoney() {
      this.MoneyVisible = false
    },
    addEdit(row) {
      this.tableObj = row;
      this.AddFlag = true;
    },
    NoneChannel() {
      this.getList();
      this.AddFlag = false;
    },
    addOpen(row) {
      this.id = row.referral_id;
      this.innerVisible = true;
    },
    noneDlg() {
      this.innerVisible = false;
    },
  },

  mounted() {
  },
};
</script>
<style lang="scss" scoped>
.Box {
  & ::v-deep el-card__body {
    padding: 0 !important;
  }
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}

.Coimage {
  width: 80px;
  height: 80px;
}

.input-with-pcenter {
  display: flex;
  align-items: center;
}

.input-with-pcenter .el-input {
  flex: 1;
}

.input-with-pcenter .pcenter {
  margin-left: 20px;
  /* 你可以根据需要调整间距 */
}

.center-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.center-content .el-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.demo-drawer__content {
  height: calc(100% - 80px); /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto; /* 添加垂直滚动条 */
  overflow-x: hidden;
}

.form-wrapper {
  padding-bottom: 80px; /* 给表单内容添加底部间距,留出按钮区域 */
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}

::v-deep .el-drawer__close-btn{
  font-size: 30px;
  font-weight: bold;
}
</style>
